import getBuyerAPIDomain from "../getBuyerAPIDomain";
import isDevMode from "../environment.function";

const untrackVehicle = async (
  vrm: string | string[],
  saleCode: string,
  inventoryID: string | null,
  authToken: string,
  isToUseAuthZero: boolean
) => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);

  if (isDevMode()) {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(
    `${buyerAPIDomain.href}/buyer/tracked/${vrm}/${saleCode}?inventoryID=${inventoryID}`,
    {
      method: "DELETE",
      headers,
    }
  );

  if (res.status === 200) {
    return res.json().catch(() => res);
  }

  return res;
};

export default untrackVehicle;
